import { useMemo, useEffect } from "react";

// API Calls
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { storeAppUsers } from "src/redux/actions/Structure.Actions";
import { useSelector, useDispatch } from "react-redux";
import AmplifyAPIWrapper from "src/API/AmplifyAPIWrapper";
import { IUser } from "@vmosolutions/oc-interfaces";

interface IShowUserInfoProps {
  /** The items to display in the summary view */
  userId: string;
  getUserLabel: (user: IUser) => string;
}

/**
 * Takes a user _id and displays a label stringf using provided formatting function.
 * @param props - Properties of the component, see [[IShowUserInfoProps]]
 */
export const ShowUserInfo = (props: IShowUserInfoProps): JSX.Element => {
  const { userId, getUserLabel } = props;
  // const theme: Theme = useTheme();
  // const classes = useStyles(theme);
  const dispatch = useDispatch();
  const appUsers = useSelector((state: IRootState) => state.structures.appUsers);

  useEffect(() => {
    const getUsersAction = async (): Promise<void> => {
      const response = await AmplifyAPIWrapper.GetPaginate<IUser>("/users");
      if (response) dispatch(storeAppUsers(response));
    };
    if (appUsers?.length === 0) getUsersAction();
  }, [dispatch, appUsers]);

  // Return user object for supplied user _id if found.
  const displayUser = useMemo(() => {
    if (!appUsers || appUsers?.length === 0 || !userId) {
      return null;
    }
    return appUsers.find((user) => user._id === userId);
  }, [appUsers, userId]);

  return <>{getUserLabel && displayUser ? getUserLabel(displayUser) : "Unknown"}</>;
};
